/*
 * Cart drawer Shipping Protection switch (snippets/seatfit-shipping-protection.liquid). Liquid prints the variant that
 * equals 10% of the cart total (data-target-variant) and the variant already in the cart (data-current-variant).
 * The switch adds or removes that hidden product through /cart/update.js with Shopify's bundled section rendering,
 * then hands the new HTML to Shrine's <cart-drawer> renderContents (Dawn API) so the drawer updates in place; if the
 * theme API is missing the page reloads. The drawer is re-rendered after every cart change and inserted scripts do not
 * run again, so this file registers once; a MutationObserver re-syncs each new copy: wrong variant after the cart
 * total changed, quantity above 1, or protection left alone in the cart.
 */
(function () {
  'use strict';
  if (window.SeatFitShippingProtection) return;
  var busy = false;
  var lastSync = '';

  function box() { return document.querySelector('[data-sf-sp]'); }

  function sectionIds(drawer) {
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
        if (ids.length) return ids;
      }
    } catch (e) { /* fall through to the Dawn defaults */ }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function apply(updates) {
    if (busy) return;
    busy = true;
    var drawer = document.querySelector('cart-drawer');
    var b = box();
    if (b) b.classList.add('sf-sp--busy');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds(drawer), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status) throw new Error(state.description || state.message || 'cart error');
      if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
        drawer.renderContents(state);
      } else {
        window.location.reload();
      }
      try {
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'seatfit-shipping-protection', cartData: state });
        }
      } catch (e) { /* optional */ }
    }).catch(function (e) {
      console.warn('[SeatFit] shipping protection', e);
      window.location.reload();
    }).then(function () { busy = false; });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-sf-sp-toggle]');
    if (!t) return;
    ev.preventDefault();
    var b = t.closest('[data-sf-sp]');
    if (!b) return;
    var qty = parseInt(b.getAttribute('data-current-qty') || '0', 10);
    var target = b.getAttribute('data-target-variant');
    var current = b.getAttribute('data-current-variant');
    var u = {};
    if (qty > 0 && current) u[current] = 0; else if (target) u[target] = 1;
    if (Object.keys(u).length) apply(u);
  });

  // Keep the protection line in step with the cart after any other cart change.
  function sync() {
    var b = box();
    if (!b || busy) return;
    var target = b.getAttribute('data-target-variant');
    var current = b.getAttribute('data-current-variant');
    var qty = parseInt(b.getAttribute('data-current-qty') || '0', 10);
    var key = target + ':' + current + ':' + qty;
    if (key === lastSync) return;
    var u = null;
    if (qty > 0 && target && current && target !== current) { u = {}; u[current] = 0; u[target] = 1; }
    else if (qty > 1 && current) { u = {}; u[current] = 1; }
    else if (qty > 0 && !target && current) { u = {}; u[current] = 0; }   // protection alone in the cart
    if (u) { lastSync = key; apply(u); }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }
  try {
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', queue);
    queue();
  } catch (e) {
    console.warn('[SeatFit] shipping protection init', e);
  }
  window.SeatFitShippingProtection = { sync: sync, apply: apply };
})();
